import React, { useCallback } from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { getPath } from "../../utils";
import { makeStyles } from "@material-ui/core/styles";
import commonStyles from "../../static/styles/common";
import { Api } from "../../services/config/request";
import SpinnerCircular from "sushiweb/Spinner/SpinnerCircular";
import { DirectUploadProvider } from "react-activestorage-provider";
import AddEdit from "sushiweb/Icons/all/AddEdit";

const useStyles = makeStyles((_theme) => commonStyles.fileUploadButton);
const maxFileSizeInMegaBytes = 5;
const maxFileSizeInBytes = maxFileSizeInMegaBytes * 1024 * 1024;
const FleetCoachImageUpload = (props) => {
  const {
    shouldUploadFile,
    setStatus,
    onUploadSuccess,
    directUploadPath,
    handleDirectUploadFailure,
    imageUrl,
    setFileUploaded,
  } = props;
  const classes = useStyles();
  const [imageSrc, setImageSrc] = React.useState("");
  const [currentImage, setCurrentImage] = React.useState({});
  React.useEffect(() => {
    setImageSrc(imageUrl);
  }, [imageUrl]);
  const GetDirectUploadPath = useCallback(() => {
    return directUploadPath;
  }, [directUploadPath]);

  const RenderFileInput = () => {
    return (
      <input
        type="file"
        accept={["image/jpg", "image/jpeg", "image/png"]}
        style={{ opacity: 0, position: "absolute", width: 120, height: 120 }}
        id={"image-upload"}
        multiple={false}
        onChange={(e) => {
          if (e.currentTarget.files.length === 0) {
            setStatus({
              type: "error",
              message: `Please select some images`,
            });
            return;
          }
          if (e.currentTarget.files[0].size > maxFileSizeInBytes) {
            setStatus({
              type: "error",
              message: `Profile Image size should be less than ${maxFileSizeInMegaBytes}MB`,
            });
            return;
          }
          setCurrentImage(e.currentTarget.files[0]);
          var reader = new FileReader();
          reader.onload = function (ev) {
            setImageSrc(ev.target.result);
            setFileUploaded(true);
          };
          reader.readAsDataURL(e.currentTarget.files[0]);
        }}
      />
    );
  };
  return (
    <ImageUploadContainer>
      <ImageContainer imageUrl={imageSrc}>
        {imageSrc.length ? (
          <React.Fragment>
            <label for="image-upload">
              <img src={imageSrc} alt="" />
            </label>
            <EditLabel>
              <AddEdit size={12} />
              Edit
            </EditLabel>
            <RenderFileInput />
          </React.Fragment>
        ) : (
          <Button
            variant="outlined"
            style={{
              position: "relative",
              border: "none",
              width: 120,
              height: 120,
            }}
            component="span"
            // className={classes.uploadButton}
          >
            {`upload`}
            <RenderFileInput />
          </Button>
        )}
      </ImageContainer>
      <p className={`${classes.fileName} mt-10`}>
        {getPath(currentImage, `name`, false)}
      </p>
      {shouldUploadFile && (
        <DirectUploadProvider
          headers={Api.headers()}
          directUploadsPath={GetDirectUploadPath()}
          onSuccess={(res) => {
            // setUploaded(true);
            onUploadSuccess(res[0]);
          }}
          onBeforeBlobRequest={({ id, file, xhr }) => {
            xhr.responseType = "json";
          }}
          render={({ handleUpload, uploads, ready }) => {
            if (ready) {
              handleUpload([currentImage]);
            }
            return (
              <div>
                {uploads.map((upload) => {
                  switch (upload.state) {
                    case "waiting":
                      return <p key={upload.id}>Waiting to upload</p>;
                    case "uploading":
                      return (
                        <p key={upload.id}>
                          <SpinnerCircular size={"small"} />
                          {Math.floor(upload.progress)}%
                        </p>
                      );
                    case "error": {
                      handleDirectUploadFailure(upload.error);
                      return (
                        <p key={upload.id}>Error uploading: {upload.error}</p>
                      );
                    }
                  }
                })}
              </div>
            );
          }}
        />
      )}
    </ImageUploadContainer>
  );
};
const ImageUploadContainer = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto 30px auto;
`;
const EditLabel = styled.div`
  position: absolute;
  display: flex;
  bottom: 0px;
  font-size: 10px !important;
  cursor: pointer;
`;
const ImageContainer = styled.div`
  width: 120px;
  height: 120px;
  background-color: ${(props) =>
    props.imageUrl ? "" : `rgba(128, 128, 128, 0.36)`};
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  &:hover {
    cursor: pointer;
  }
`;

export default FleetCoachImageUpload;
